import * as request from '@/utils/request'
import { getLevel } from '@/utils/chat/chatUtil';


let api = '';


export const getAnswer = (params) => request.post(api + '/Chat', params);

// 身份证识别机器人获取答案接口
export const getIdCardRecChat = (params) => request.post(api + '/IDCardRecAgent', params);

// 图表工具获取答案接口
export const getChartTool = (params) => request.post(api + '/ChartTool', params);

// 开始新会话
export const startNewSession = () => request.post(api + '/NewSession', { level: getLevel() });

export const download = (params) => request.downloadPost(api + `/downloadChat`, params)

export const delSession = (params) => request.post(api + '/DelSession', params)


// 流式接口
export const stream = (params) => request.streamPost(api + '/Stream', params);

// 老师下载
export const teacherDownload = (params) => request.downloadPost(api + '/downloadTeacherPdf', { ...params, level: getLevel() });

// 学生下载
export const studentDownload = (params) => request.downloadPost(api + '/downloadStudentDocx', { ...params, level: getLevel() });

// 试题下载 downloadPaper
export const paperDownload = (params) => request.downloadPost(api + '/downloadPaper', params);

// 答案下载 downloadPaperAnswer
export const answerDownload = (params) => request.downloadPost(api + '/downloadPaperAnswer', params);


// 收藏题目
export const collectQuestion = (params) => request.post(api + '/collectQuestions', { ...params, level: getLevel() });

// 移除收藏
export const removeCollect = (params) => request.post(api + '/RemoveCollectQuestions', { ...params, level: getLevel() });

// 获取题目收藏列表
export const getQustionCollectionList = () => request.post(api + '/showCollectQuestions', { level: getLevel() });

// 收藏试题
export const collectPaper = (params) => request.post(api + '/collectPapers', params);

// 移除试题收藏
export const removePaperCollect = (params) => request.post(api + '/RemovePapers', params);

// 根据知识点在下方增加题目
export const addquestionsBelowByPoint = (params) => request.post(api + '/AddQuestionsBelow', params);


// 展示试题
export const showPaper = (params) => request.post(api + '/showPapers', params);


// 获取试卷收藏列表
export const getPaperCollectionList = () => request.post(api + '/showPaperNames');

// 获取错题列表
export const getWrongList = () => request.post(api + '/showIncorrectQuestions', { level: getLevel() });

// 获取知识墙
export const getWallList = () => request.post(api + '/showKnowledgeWall', { level: getLevel() });

// 知识墙推荐的题目
export const getRecommend = (params) => request.post(api + '/recommendByKnowledgeWall', { ...params, level: getLevel() });

// 相似题替换题目
export const replaceQuestion = (params) => request.post(api + '/SimilarSubstitution', params);

// 根据知识点替换题目
export const replaceByKnowledge = (params) => request.post(api + '/KnowledgeSubstitution', params);

// 根据收藏列表替换题目
export const getReplaceList = (params) => request.post(api + '/CollectSubstitution', params);

// 获取知识图谱数据
export const getKnowledgeGraphData = (params) => request.post(api + '/ShowMethods', params);

// 获取数学水平
// export const getMathLevel = () => request.post(api + '/ShowMathLevel', { level: getLevel() })
export const getMathLevel = (params = {}) => {
    const level = params.level || getLevel();  // 优先使用传入的等级
    return request.post(api + '/ShowMathLevel', {level, _t: Date.now()});
  };

// 获取专题收藏列表
export const showTopicNames = () => request.post(api + '/showTopicNames', {level: getLevel() })

// 展示专题
// params {'titLe':'三次函数’'Level':'h'}
export const showTopic = (params) => request.post(api + '/showTopic', params)

// 收藏专题
// params {'title':'三次函数''level':'h'}
export const collectTopic = (params) => request.post(api + '/collectTopic', params)

// 移除专题
// params {'title':"二次数’'level':'h'}
export const removeTopic = (params) => request.post(api + '/removeTopic', params)

// 生成专属深度研究报告（流式）
export const deepResearch = (params) => request.streamPost('/deepResearch', params);

// ════════ 图谱弹窗专用下载（level 由调用方显式传入，不读全局） ════════
// params 需含 level（图谱自带学段），后端按 level 去对应文件夹取数据
export const teacherDownloadForGraph = (params) =>
  request.downloadPost(api + '/downloadTeacherPdf', { ...params, level: params.level });

export const studentDownloadForGraph = (params) =>
  request.downloadPost(api + '/downloadStudentDocx', { ...params, level: params.level });
